import React from 'react';
import { Form, Input, Button, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useMutation } from '@tanstack/react-query';
import { changePassword } from '../../Services/user';

const { Paragraph } = Typography;

// Styled components
const PageWrapper = styled.div`
  max-width: 500px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 8px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  background: #fff;
`;

const FormWrapper = styled(Form)`
  .ant-form-item {
    margin-bottom: 20px;
  }
`;


const StyledParagraph = styled(Paragraph)`
  text-align: left;
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
`;

const SubmitButton = styled(Button)`
  width: 100%;
`;

const ChangePasswordPage = () => {
  const [form] = Form.useForm();

  const mutation = useMutation({
    mutationFn: changePassword,
    onSuccess: () => {
      form.resetFields(); 
    },
  });
  
  const onFinish = (values) => {
    mutation.mutate({
      current_password: values.oldPassword, // Old password
      new_password: values.newPassword, // New password
    });
  };

  const validatePassword = (_, value) => {
    if (value && value.length < 6) {
      return Promise.reject('Password must be at least 6 characters long');
    }
    if (!/[A-Z]/.test(value) && value ) {
      return Promise.reject('Password must contain at least one uppercase letter (A-Z)');
    }
    if (!/[0-9]/.test(value)  && value) {
      return Promise.reject('Password must contain at least one number (0-9)');
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)  && value) {
      return Promise.reject('Password must contain at least one special character (!@#$%^&*)');
    }
    return Promise.resolve();
  };
  

  return (
    <PageWrapper>
      <h3 level={3}>Change Password</h3>
      <StyledParagraph>
       Please enter your Current Password and reset a New password. <br />
        Make sure your new password is strong and secure. <br />
        Confirm your new password to ensure accuracy.
      </StyledParagraph>
      <FormWrapper
        form={form}
        onFinish={onFinish}
        layout="vertical"
        initialValues={{ remember: true }}
      >
        <Form.Item
          name="oldPassword"
          label="Current Password"
          rules={[{ required: true, message: 'Please enter your Current Password' }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Enter Current Password"
          />
        </Form.Item>

        <Form.Item
          name="newPassword"
          label="New Password"
          rules={[
            { required: true, message: 'Please enter your New Password' },
            { validator: validatePassword },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (value && value === getFieldValue('oldPassword')) {
                  return Promise.reject(new Error('New Password cannot be the same as the Current Password'));
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Enter New Password"
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: 'Please enter your Confirm Password' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The two passwords do not match!'));
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Confirm your New Password"
          />
        </Form.Item>

        <Form.Item>
          <SubmitButton loading={mutation?.isPending} type="primary" htmlType="submit">
            Change Password
          </SubmitButton>
        </Form.Item>
      </FormWrapper>
    </PageWrapper>
  );
};

export default ChangePasswordPage;
